import {
  LOCAL_SETTINGS_LAYOUT_LOGIN_MARGIN_TOP,
  LOCAL_SETTINGS_PNL_IN_TAB_TOGGLE,
  LOCAL_SETTINGS_SHOW_ORDER_ID_TOGGLE,
  LOCAL_SETTINGS_SOUND_TOGGLE,
  LOCAL_SETTINGS_UNDERLYING_PRICE_TICKER_TOGGLE,
  SET_LOCAL_SETTINGS_EXPIRY_NOTIFICATION_CLOSE,
} from '../../constants/ActionTypes';
import {
  getLocalSettingsPnlInTab,
  getLocalSettingsShowOrderIds,
  getLocalSettingsSounds,
  getLocalSettingsUnderlyingPriceTicker,
} from '../../helpers/local-settings';
import storage from '../../storage';

const localSettings = (
  state = {
    sounds: getLocalSettingsSounds(),
    pnlInTab: getLocalSettingsPnlInTab(),
    underlyingPriceTicker: getLocalSettingsUnderlyingPriceTicker(),
    showOrderIds: getLocalSettingsShowOrderIds(),
    expirySettings: {
      notificationClosedToday: storage.getItem('expiryWarningClosedAt') || null,
    },
    layoutLoginMarginTop: 0,
  },
  action
) => {
  switch (action.type) {
    case LOCAL_SETTINGS_SOUND_TOGGLE:
      // eslint-disable-next-line no-case-declarations
      const newSounds = { ...state.sounds };

      newSounds[action.name] = !newSounds[action.name];

      storage.setItems({
        sounds: newSounds,
      });

      return {
        ...state,
        sounds: {
          ...newSounds,
        },
      };
    case SET_LOCAL_SETTINGS_EXPIRY_NOTIFICATION_CLOSE:
      storage.setItems({
        expiryWarningClosedAt: action.data,
      });

      return {
        ...state,
        expirySettings: {
          ...state.expirySettings,
          notificationClosedToday: action.data,
        },
      };
    case LOCAL_SETTINGS_PNL_IN_TAB_TOGGLE:
      // eslint-disable-next-line no-case-declarations
      const newPnlInTab = { ...state.pnlInTab };

      newPnlInTab[action.name] = !newPnlInTab[action.name];

      storage.setItems({
        pnlInBrowserTab: newPnlInTab,
      });

      return {
        ...state,
        pnlInTab: {
          ...newPnlInTab,
        },
      };
    case LOCAL_SETTINGS_UNDERLYING_PRICE_TICKER_TOGGLE:
      // eslint-disable-next-line no-case-declarations
      const newUnderlyingPriceTicker = { ...state.underlyingPriceTicker };

      newUnderlyingPriceTicker[action.symbol] = action.toggleState;

      storage.setItems({
        underlyingPriceTicker: newUnderlyingPriceTicker,
      });

      return {
        ...state,
        underlyingPriceTicker: {
          ...newUnderlyingPriceTicker,
        },
      };
    case LOCAL_SETTINGS_SHOW_ORDER_ID_TOGGLE:
      // eslint-disable-next-line no-case-declarations
      const newShowOrderids = !state.showOrderIds;

      storage.setItems({
        showOrderIds: newShowOrderids,
      });

      return {
        ...state,
        showOrderIds: newShowOrderids,
      };
    case LOCAL_SETTINGS_LAYOUT_LOGIN_MARGIN_TOP:
      return {
        ...state,
        layoutLoginMarginTop: action.value,
      };
    default:
      return state;
  }
};

export default localSettings;
